var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-content"},[_c('div',{staticClass:"app-title"},[_c('div',[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"truck"}}),_vm._v("\n          "+_vm._s(_vm.$t('logisticsCompany'))+"\n        ")],1)])]),(_vm.tabIndex === 0)?_c('carrier-gateway-list'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }